import makeSettings from "@/settings";
import {overrideSettings} from "./url";

export default container => {
    container.declare("settings", () => {
        const preSettings = {};
        overrideSettings(preSettings);
        const settings = makeSettings({product: preSettings.product || process.env.VUE_APP_SAH_PRODUCT});
        overrideSettings(settings);
        return settings;
    });
};
